import http from "./config/NetworkClient";

export default class AuthApi {
  static async login(payload) {
    const response = await http.postWithoutAuth(
      "/authentication/token",
      payload
    );
    return response;
  }
  static async getId(payload) {
    const res = await http.postWithoutAuth(
      `/client/public/user_profile`,
      payload
    );
    return res;
  }
  static async userInfo() {
    const res = await http.getWithAuth("/authentication/user/info");
    return res;
  }
  static async updateUserInfo(payload) {
    const res = await http.put("/authentication/user/info", payload);
    return res;
  }
  static async userProfileInfo() {
    const res = await http.get("/client/public/user_profile");
    return res;
  }
  static async updateUserProfileInfo(payload) {
    const res = await http.put("/client/public/user_profile", payload);
    return res;
  }

  static async validatedMobileNumber(payload) {
    const res = await http.get(
      `/client/public/phone_number_validation`,
      payload
    );
    return res;
  }
  static async getFamilyMembers() {
    const res = await http.get("/api/v3/user-relatives");
    return res;
  }
  static async addFamilyMembers(payload) {
    const res = await http.post("/api/v3/user-relative", payload);
    return res;
  }
  static async deleteFamilyMembers(id) {
    const res = await http.del(`/api/v3/user-relative/${id}`);
    return res;
  }
  static async updateNotification(param) {
    const res = await http.put(
      `/client/public/user_appointment_notification`,
      param
    );
    return res;
  }
  static async inactiveUser() {
    const response = await http.put("/api/v3/user/delete");
    return response;
  }
}
